export const entitiesToBlocks = entities => {
  if (!entities) {
    entities = ''
  }

  if (!Array.isArray(entities)) {
    entities = [entities]
  }

  entities = padWithEmptyStrings(entities)

  let result = [[]]
  let currentBlock = 0

  for (let entity of entities) {
    if (typeof entity === 'string') {
      let parts = entity.split('\n')
      result[currentBlock].push(parts[0])

      for (let part of parts.slice(1)) {
        currentBlock += 1
        result.push([])

        result[currentBlock].push(part)
      }
    } else {
      result[currentBlock].push(entity)
    }
  }

  return result
}

export const blocksToEntities = blocks => {
  let result = []

  for (let i = 0; i < blocks.length; i += 1) {
    if (i > 0) {
      result.push('\n')
    }

    result = result.concat(blocks[i])
  }

  return mergeAdjacentStrings(result)
}

export const mergeAdjacentStrings = entities => {
  let result = []

  for (let i = 0; i < entities.length; i += 1) {
    if (typeof entities[i] === 'string') {
      let string = entities[i]

      for (i = i + 1; typeof entities[i] === 'string'; i += 1) {
        string += entities[i]
      }

      i -= 1

      result.push(string)
    } else {
      result.push(entities[i])
    }
  }

  return result
}

export const padWithEmptyStrings = entities => {
  entities = [...entities]

  for (let i = 0; i <= entities.length; i += 1) {
    if (typeof entities[i] !== 'string') {
      if (typeof entities[i - 1] !== 'string') {
        entities.splice(i, 0, '')
        i += 1
      }
    }
  }

  return entities
}
